import { Component, Input, OnInit } from '@angular/core';
import { EligibilityVerificationType } from '@ktypes/enums';

export interface VerificationDetails {
  description?: string;
  route?: string;
  buttonText?: string;
}

@Component({
  selector: 'kp-eligibility-verification-type',
  templateUrl: './eligibility-verification-type.component.html',
  styleUrls: ['./eligibility-verification-type.component.scss'],
})
export class EligibilityVerificationTypeComponent implements OnInit {
  @Input() eligibilityVerificationType: EligibilityVerificationType;

  verificationDetails: VerificationDetails;

  ngOnInit(): void {
    switch (this.eligibilityVerificationType) {
      case EligibilityVerificationType.email:
        this.verificationDetails = {
          description: 'Verify using your work email address.',
          route: `/welcome/eligibility/${EligibilityVerificationType.email}`,
          buttonText: 'Use Work Email',
        };
        break;
      case EligibilityVerificationType.employee_identifier:
        this.verificationDetails = {
          description: 'Verify using your employee ID.',
          route: `/welcome/eligibility/${EligibilityVerificationType.employee_identifier}`,
          buttonText: 'Use Employee ID',
        };
        break;
      case EligibilityVerificationType.member_identifier:
        this.verificationDetails = {
          description: 'Verify using your member ID.',
          route: `/welcome/eligibility/${EligibilityVerificationType.member_identifier}`,
          buttonText: 'Use Member ID',
        };
        break;
      case EligibilityVerificationType.postal_dob_name:
        this.verificationDetails = {
          description: 'Verify using your name, date of birth, and ZIP code.',
          route: `/welcome/eligibility/${EligibilityVerificationType.postal_dob_name}`,
          buttonText: 'Use Personal Details',
        };
        break;
      case EligibilityVerificationType.student_email:
        this.verificationDetails = {
          description: 'Verify using your student email address.',
          route: `/welcome/eligibility/${EligibilityVerificationType.student_email}`,
          buttonText: 'Use Student Email',
        };
        break;
      case EligibilityVerificationType.student_identifier:
        this.verificationDetails = {
          description: 'Verify using your student ID.',
          route: `/welcome/eligibility/${EligibilityVerificationType.student_identifier}`,
          buttonText: 'Use Student ID',
        };
        break;
    }
  }
}
